/**
 * QR como SVG (FASE 8.1). Se genera en el navegador a partir del texto
 * (`qr.ts`, sin dependencias); nunca se descarga ni se guarda una imagen.
 */
import { useMemo, type ReactNode } from 'react';

import { generarQr, trazadoQr } from '../qr.ts';

export function CodigoQr({ texto, tamano = 180, titulo }: { texto: string; tamano?: number; titulo: string }): ReactNode {
  const { lado, d } = useMemo(() => trazadoQr(generarQr(texto)), [texto]);
  return (
    <svg
      className="codigo-qr"
      role="img"
      aria-label={titulo}
      width={tamano}
      height={tamano}
      viewBox={`0 0 ${String(lado)} ${String(lado)}`}
      shapeRendering="crispEdges"
    >
      <rect width={lado} height={lado} fill="#fff" />
      <path d={d} fill="#000" />
    </svg>
  );
}
